<template>
    <Layout>
        <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6 col-xl-5">
                <div class="card overflow-hidden">
                    <div class="bg-soft-primary">
                        <div class="row">
                            <div class="col-7">
                                <div class="text-primary p-4">
                                    <h5 class="text-primary">Witamy!</h5>
                                    <p>Jeśli masz problemy z logowaniem, utwórz konto offline.</p>
                                </div>
                            </div>
                            <div class="col-5 align-self-end">
                                <img
                                    alt
                                    class="img-fluid"
                                    src="@/assets/images/profile-img.png"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-0">
                        <div>
                            <router-link tag="a" to="/">
                                <div class="avatar-md profile-user-wid mb-4">
                                  <span class="avatar-title rounded-circle bg-light">
                                    <img alt height="34" src="@/assets/images/logo.svg"/>
                                  </span>
                                </div>
                            </router-link>
                        </div>
                        <b-alert
                            v-model="isError"
                            class="mt-3"
                            dismissible
                            variant="danger"
                        >{{ message }}
                        </b-alert
                        >

                        <div
                            v-if="notification.message"
                            :class="'alert ' + notification.type"
                        >
                            {{ notification.message }}
                        </div>

                        <div>
                            <loader :active="loading" :bgColor="theme.themeColor2"/>
                            <div>
                                <b-form v-if="step == 1" class="p-2" @submit.prevent="handleSendId">
                                    <h5 class="mb-3"> 1. Wpisz swoje Unikalne ID lub Database ID </h5>

                                    <b-form-group
                                        id="input-group-1"
                                        label="ID"
                                        label-for="input-1"
                                    >
                                        <b-form-input
                                            id="input-1"
                                            v-model="id"
                                            :class="{ 'is-invalid': $v.id.$error }"
                                            placeholder="Wprowadź uid lub dbid"
                                            type="text"
                                        ></b-form-input>
                                        <div
                                            v-if="$v.id.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.id.required">To pole jest wymagane.</span>
                                        </div>
                                    </b-form-group>

                                    <div class="mt-5 d-flex justify-content-center">
                                        <button class="btn btn-primary ml-2 mr-2" type="submit"><i class="fa fa-arrow-right"></i> Dalej</button>
                                    </div>
                                </b-form>

                                <b-form v-else-if="step == 2" class="p-2" @submit.prevent="handleOnChannel">
                                    <h5 class="mb-3">
                                        2. Wejdź na kanał: <ul class="teamspeak-channels mt-3"><channel :channel="channelInfo.channel"/></ul>
                                    </h5>
                                    <div class="mt-5 d-flex justify-content-center">
                                        <button class="btn btn-primary ml-2 mr-2" type="submit"><i class="fa fa-arrow-right"></i> Dalej</button>
                                        <button class="btn btn-danger ml-2 mr-2" @click.prevent="goBack()"><i class="fa fa-arrow-left"></i> Powrót</button>
                                    </div>
                                </b-form>

                                <form class="needs-validation" v-else-if="step == 3" @submit.prevent="handleCreate">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h5 class="mb-3"> 3. Utwórz konto </h5>

                                            <div class="form-group">
                                                <label for="create-email">Token, który wysłał Ci bot</label>
                                                <input
                                                    id="create-token"
                                                    v-model="create.token"
                                                    :class="{ 'is-invalid': $v.create.token.$error }"
                                                    class="form-control"
                                                    placeholder="******"
                                                    type="text"
                                                />
                                                <div v-if="$v.create.token.$error" class="invalid-feedback">
                                                    <span v-if="!$v.create.token.required">Token jest wymagany.</span>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for="create-email">Email</label>
                                                <input
                                                    id="create-email"
                                                    v-model="create.email"
                                                    :class="{ 'is-invalid': $v.create.email.$error }"
                                                    class="form-control"
                                                    placeholder="email@gmail.com"
                                                    type="email"
                                                />
                                                <div v-if="$v.create.email.$error" class="invalid-feedback">
                                                    <span v-if="!$v.create.email.required">Email jest wymagany.</span>
                                                    <span v-if="!$v.create.email.email">To musi być poprawny email.</span>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for="create-password">Hasło</label>
                                                <input
                                                    id="create-password"
                                                    v-model="create.password"
                                                    :class="{ 'is-invalid': $v.create.password.$error }"
                                                    class="form-control"
                                                    placeholder="123456"
                                                    type="password"
                                                />
                                                <div v-if="$v.create.password.$error" class="invalid-feedback">
                                                    <span v-if="!$v.create.password.required">Hasło jest wymagane.</span>
                                                    <span v-if="!$v.create.password.minLength">Hasło musi mieć co najmniej 6 znaków.</span>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label for="create-confirmPassword">Powtórz Hasło</label>
                                                <input
                                                    id="create-confirmPassword"
                                                    v-model="create.confirmPassword"
                                                    :class="{ 'is-invalid': $v.create.confirmPassword.$error }"
                                                    class="form-control"
                                                    placeholder="123456"
                                                    type="password"
                                                />
                                                <div v-if="$v.create.confirmPassword.$error"
                                                     class="invalid-feedback">
                                                    <span v-if="!$v.create.confirmPassword.required">Potwierdzenie hasła jest wymagane.</span>
                                                    <span v-if="!$v.create.confirmPassword.sameAsPassword">Hasła muszą być takie same.</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-around">
                                        <button class="btn btn-primary" :disabled="loading">
                                            <span><i class="fa fa-plus"></i> Utwórz konto offline</span>
                                        </button>
                                        <button class="btn btn-danger ml-2 mr-2" @click.prevent="goBack()"><i class="fa fa-arrow-left"></i> Powrót</button>
                                    </div>
                                </form>

                                <b-form v-if="step == 4" class="p-2" @submit.prevent="handleVerify">
                                    <h5 class="mb-3"> 4. Wpisz token otrzymany na maila </h5>

                                    <b-form-group
                                        id="input-group-1"
                                        label="Token"
                                        label-for="input-1"
                                    >
                                        <b-form-input
                                            id="input-1"
                                            v-model="emailToken"
                                            :class="{ 'is-invalid': $v.emailToken.$error }"
                                            placeholder="*** ***"
                                            type="text"
                                        ></b-form-input>
                                        <div
                                            v-if="$v.emailToken.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.emailToken.required">To pole jest wymagane.</span>
                                        </div>
                                    </b-form-group>

                                    <div class="mt-5 d-flex justify-content-center">
                                        <button class="btn btn-primary ml-2 mr-2" type="submit"><i class="fa fa-check"></i> Potwierdź</button>
                                        <button class="btn btn-info ml-2 mr-2" @click.prevent="resendEmail"><i class="fa fa-sync"></i> Wyślij ponownie</button>
                                    </div>
                                </b-form>
                            </div>
                        </div>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card -->

                <div class="mt-5 text-center">
                    <p>
                        Jednak jesteś na serwerze?
                        <router-link
                            :to="{ name: 'loginToken'}"
                            class="font-weight-medium text-primary"
                            tag="a"
                        >
                            Zaloguj się przez token
                        </router-link>
                    </p>
                    <p>
                        © {{ new Date().getFullYear() }} {{ cfg.global.information.serverName }}. Made with
                        <i class="mdi mdi-heart text-danger"></i> by <a href="http://ro-bot.pl" target="_blank" class="robot">RO-BOT</a>
                    </p>
                </div>
                <!-- end row -->
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </Layout>
</template>

<script>
import Layout from "../../layouts/auth";
import {
    notificationMethods,
} from "@/state/helpers";

import AuthService from "@/services/auth.service";
import {email, minLength, required, sameAs} from "vuelidate/lib/validators";

export default {
    name: "CreateOfflineAccount",
    components: {
        Layout,
    },
    data() {
        return {
            id: '',
            loading: true,
            message: '',
            step: 1,
            channelInfo: {},
            create: {},
            isError: false,
            token: '',
            emailToken: ''
        };
    },
    computed: {
        notification() {
            return this.$store ? this.$store.state.notification : null;
        },
        theme() {
            return this.$store.getters['cfg/get'].global.theme;
        },
        cfg() {
            return this.$store.getters['cfg/get'];
        }
    },
    validations: {
        id: {
            required,
        },
        create: {
            token: {required},
            email: {required, email: email},
            password: {required, minLength: minLength(6)},
            confirmPassword: {required, sameAsPassword: sameAs('password')},
        },
        emailToken: {required}
    },
    mounted() {
        this.loading = false;
    },
    methods: {
        ...notificationMethods,
        handleSendId() {
            this.$v.id.$touch();

            if (this.$v.id.$invalid) {
                return;
            }

            this.loading = true;

            AuthService.offlineAccountSendId(this.id).then(
                response => {
                    this.message = '';
                    this.loading = false;
                    this.isError = false;
                    this.channelInfo = response.data;
                    this.step = 2;
                },
                error => {
                    this.loading = false;
                    this.message = "Undefined error";
                    this.isError = true;

                    if (error.response && error.response.data && error.response.data.message)
                        this.message = error.response.data.message;
                    else if (error.message)
                        this.message = error.message;
                    else if (error.toString())
                        this.message = error.toString();
                }
            );
        },
        handleOnChannel() {
            this.loading = true;

            AuthService.offlineAccountOnChannel(this.id).then(
                response => {
                    this.message = '';
                    this.loading = false;
                    this.isError = false;

                    if (response.data.hasOfflineAccount) {
                        this.token = response.data.token;
                        this.step = 4;
                    } else
                        this.step = 3;
                },
                error => {
                    this.loading = false;
                    this.message = "Undefined error";
                    this.isError = true;

                    if (error.response && error.response.data && error.response.data.message)
                        this.message = error.response.data.message;
                    else if (error.message)
                        this.message = error.message;
                    else if (error.toString())
                        this.message = error.toString();
                }
            );
        },
        handleCreate() {
            this.$v.create.$touch();

            if (this.$v.create.$invalid) {
                return;
            }

            this.loading = true;

            AuthService.offlineAccountCreate(this.id, this.create.token, this.create).then(
                () => {
                    this.message = '';
                    this.loading = false;
                    this.isError = false;
                    this.step = 4;
                    this.token = this.create.token;
                    this.create = {};
                },
                error => {
                    this.loading = false;
                    this.message = "Undefined error";
                    this.isError = true;

                    if (error.response && error.response.data && error.response.data.message)
                        this.message = error.response.data.message;
                    else if (error.message)
                        this.message = error.message;
                    else if (error.toString())
                        this.message = error.toString();
                }
            );
        },
        handleVerify() {
            this.$v.emailToken.$touch();

            if (this.$v.emailToken.$invalid) {
                return;
            }

            this.loading = true;

            AuthService.offlineAccountVerify(this.id, this.token, this.emailToken).then(
                () => {
                    this.success('Konto offline zostało pomyślnie utworzone!');
                    this.$router.push({name: 'loginOffline'});
                },
                error => {
                    this.loading = false;
                    this.message = "Undefined error";
                    this.isError = true;

                    if (error.response && error.response.data && error.response.data.message)
                        this.message = error.response.data.message;
                    else if (error.message)
                        this.message = error.message;
                    else if (error.toString())
                        this.message = error.toString();
                }
            );
        },
        resendEmail() {
            this.loading = true;

            AuthService.offlineAccountResend(this.id, this.token).then(
                () => {
                    this.loading = false;
                },
                error => {
                    this.loading = false;
                    this.message = "Undefined error";
                    this.isError = true;

                    if (error.response && error.response.data && error.response.data.message)
                        this.message = error.response.data.message;
                    else if (error.message)
                        this.message = error.message;
                    else if (error.toString())
                        this.message = error.toString();
                }
            );
        },
        goBack() {
            this.isError = false;
            this.message = '';

            this.step--;

            if (this.step == 1)
                this.id = '';
        },
    }
};
</script>

<style lang="scss" module></style>
